<div class="seccion1 fotoPresentacion">

</div>
<div class="contenedor-radio-noticias" id="tpTitulo">
    <app-radio-new></app-radio-new>
</div>
<!--Inicio 2da Sección Mision--> 
<div #target class="seccion2" >

    <div class="contenido-text-nosotros" >
        <div class="row contenido-row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12 col-md-8">
                                <div class="row">
                                    <div class="col-2" >
                                        <img src="assets/svg/vinilo2.svg" class="topright" alt="" width="44px"
                                            height="44px">
                                    </div>
                                    <div class="col-10">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="title-contenido-nosotros" >
                                                    <p>{{elegido.year}}</p>
                                                </div>
                                                <div class="linea-title-nosotros"></div>
                                            </div>
                                            <div class="col-12">
                                                <div class="detalle-contenido-nosotros">
                                                    <h4 class="noticia">{{elegido.detail}}</h4>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <!-- ESPACIO EN BLANCO DE DIVISION -->
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="spacer10alineadomid">
                            <svg height="64" width="500">
                                <polyline points="100,0 100,32 400,32 400,64"
                                    style="fill:none;stroke:black;stroke-width:3" />
                            </svg>
                        </div>

                    </div>
                    <div class="col-12">
                        <div class="row">
                            <div class="col-sm-4"></div>
                            <div class="col-12 col-sm-8">
                                <div class="image-size">
                                    <div class="box-principal-image">
                                        <div class="image-contenido-nosotros">
                                            <img src={{elegido.image}} alt="">
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!--Inicio Dividor V2-->
        <mat-divider class="matDivider"></mat-divider>
        <div class="trianguloPadre">
            <div class="triangle-down"></div>
        </div>
        <!--Fin Dividor V2--> 
    </div>
    
</div>
<!--Fin 2da Sección Mision--> 

<!--Inicio galeria de fotos--> 
<div class="seccion3">
    <div class="row rownew">
        <div class="contenido-image-row">
            <div class="col-12  colnew">
                <div class="seccion-imagenes-nosotros">
                    <div class="row rownew">
                        <div class="col-6 col-sm-3 boximg" *ngFor="let noticia of timeLine; let i = index"
                            (click)="elegir(target , i)">
                            <div class="contenido-seccion3">
                                <img src="{{noticia.imageMain}}" alt="">
                                <div class="contenido-seccion3-centrado shadow" *ngIf='!noticia.active'>
                                    <div class="img-contenido-tamanio-shadow">
                                        <div class="contenido-shadow-text">
                                            <div class="contenido-shadow-text-centrado">
                                                
                                                <p>{{noticia.title}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="contenido-seccion3-centrado" *ngIf='noticia.active'>
                                    <div class="img-contenido-tamanio-shadow">
                                        <div class="contenido-shadow-text">
                                            <div class="contenido-shadow-text-centrado">
                                                
                                                <p>{{noticia.title}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

    </div>
    
</div>
<!--Fin Inicio galeria de fotos--> 

<!--Inicio Dividor V2-->
<mat-divider class="matDividerTwo"></mat-divider>
<div class="trianguloPadreTwo">
    <div class="triangle-downTwo"></div>
</div>
<!--Fin Dividor V2--> 

<!--Inicio información de contacto Publicidad--> 
<section class="section-portada">
    <div class="row padlat">
        <div class="col-12 tituloPubli centreado">INFORMACIÓN DE CONTACTO PARA PUBLICIDAD</div>
        <div class="spacer5"></div>
        <div class="col-12 detalle-contenido-nosotros centreado noticia">Por favor a continuación detalle su información de
            contacto para recibir una llamada o correo de nuestro personal comercial.</div>
        <div class="spacer52"></div>
        <div class="col-12">
            <div class="row">
                <div class="col-12 centreado">
                    <form [formGroup]="myForm" (ngSubmit)="submitForm()" novalidate>
                        <mat-form-field appearance="outline" class="example-full-width-box" >
                            <mat-label>Nombre</mat-label>
                            <input matInput placeholder="Introduzca su nombre" 
                                formControlName="name">
                            <mat-error  *ngIf="errorHandling('name', 'required')">
                                Este campo debe estar lleno
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="example-full-width-box">
                            <mat-label>Correo Electrónico</mat-label>
                            <input matInput type='email' placeholder="Introduzca el correo electrónico"
                                 formControlName="email">
                            <mat-error *ngIf="errorHandling('email', 'required')">
                                Este campo debe estar lleno
                            </mat-error>
                            <mat-error *ngIf="errorHandling('email', 'email')">
                                Correo invalido
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label >Nombre de Empresa</mat-label>
                            <input matInput 
                                placeholder="Introduzca el nombre de la empresa para la cual se hara publicidad"
                                formControlName="empresa">
                            <mat-error *ngIf="errorHandling('empresa', 'required')">
                                Este campo debe estar lleno
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Mensaje</mat-label>
                            <textarea rows="7" matInput formControlName="mensaje"
                                placeholder="Describa lo que busca con el mayor detalle posible"></textarea>
                        </mat-form-field>
                    </form>
                </div>
            </div>
        </div>
    </div>
    
    <div class="col-12 centreado">
        <div class="col-12 detalle-contenido-nosotros centreado noticia">
            Elija una frencuencia para la publicidad
        </div>
        <div class="spacer5"></div>
        <div class="lineHeight" [matMenuTriggerFor]="menu">
            <p class="pmenuFrecuencia">
                {{radioElegida}} 
                <mat-icon class="arrowDownStyle">keyboard_arrow_down</mat-icon>
            </p>
            
        </div>
        <mat-menu #menu="matMenu" class="centreado">
            <button *ngFor="let radio of typesOfRadios;let i = index" (click)="eligeRadio(i)"
                mat-menu-item class="menuStyle">
                {{radio}}
            </button>
        </mat-menu>
        <div class="spacer5"></div>
        <button mat-raised-button color="warn" (click)="verificarCorreo()">Enviar</button>
        <div class="spacer5"></div>
    </div>
</section>
<!--Fin información de contacto Publicidad--> 

<footer>
    <app-footer-new></app-footer-new>
</footer>